import { useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";
import { CheckCircle2, Loader2, Search } from "lucide-react";
import { toast } from "sonner";

const digitsOf = (v) => String(v || "").replace(/\D/g, "");

// 286: IČO s načtením firmy z registru ARES. Po napsání 8. číslice se firma dohledá
// sama, lupa ji načte znovu. onFound dostane { name, ico, dic, vat_payer, street, zip, city }.
export function IcoInput({ value, onChange, onFound, className = "", testid = "ico" }) {
  const [state, setState] = useState(null);   // "busy" | "ok" | null
  const cur = useRef("");                       // IČO, na které se právě ptáme / které je načtené

  const load = async (ico) => {
    cur.current = ico;
    setState("busy");
    try {
      const { data } = await api.get(`/investors/ares/${ico}`);
      if (cur.current !== ico) return;          // mezitím se IČO změnilo
      onFound(data);
      setState("ok");
    } catch (e) {
      if (cur.current !== ico) return;
      cur.current = "";
      setState(null);
      toast.error(formatApiError(e.response?.data?.detail) || "Registr neodpověděl — vyplňte údaje ručně.");
    }
  };

  const change = (e) => {
    onChange(e.target.value);
    const d = digitsOf(e.target.value);
    if (d === cur.current) return;
    if (d.length === 8) load(d);
    else { cur.current = ""; setState(null); }
  };

  const ready = digitsOf(value).length === 8;
  return (
    <div className="relative min-w-0">
      <Input value={value || ""} onChange={change} inputMode="numeric" autoComplete="off" placeholder="Načte z ARES"
        className={`${className} pr-11 md:pr-10`} data-testid={testid} />
      <button type="button" onClick={() => load(digitsOf(value))} disabled={!ready || state === "busy"}
        title="Načíst firmu z registru ARES" aria-label="Načíst firmu z registru ARES" data-testid={`${testid}-ares`}
        className={`absolute right-0.5 top-1/2 -translate-y-1/2 h-10 w-10 md:h-9 md:w-9 grid place-items-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted disabled:hover:bg-transparent disabled:hover:text-muted-foreground ${state === "busy" ? "" : "disabled:opacity-40"}`}>
        {state === "busy" ? <Loader2 size={16} className="animate-spin motion-reduce:animate-none" />
          : state === "ok" ? <CheckCircle2 size={16} className="text-success" data-testid={`${testid}-ok`} />
          : <Search size={16} />}
      </button>
    </div>
  );
}
